import { render } from "./InfractionsList.vue?vue&type=template&id=ef79139e&scoped=true"
import script from "./InfractionsList.vue?vue&type=script&lang=js"
export * from "./InfractionsList.vue?vue&type=script&lang=js"

import "./InfractionsList.vue?vue&type=style&index=0&id=ef79139e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef79139e"]])

export default __exports__